export const billSupplyAuthorizationTableColumns = [
  { label: 'Status', value: 'status' },
  { label: 'N do empenho contábil', value: 'allocation_accounting_number' },
  { label: 'Autor', value: 'author' },
  { label: 'Data de envio', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
